export const Zona = {
    Circondario: 0,
    Distretto: 1,
}

export const ZonaOptions =
    Object.keys(Zona).map(e => {
        return {
            label: e,
            zona: Zona[e],
        }
    })

export const TipoContatto = {
    Email: "Email",
    Telefono: "Telefono",
    Fax: "Fax",
    Pec: "Pec",
    SitoWeb: "SitoWeb",
    AssistenzaPct: "AssistenzaPct",
    Referente: "Referente",
    Urp: "Urp",
    Casellario: "Casellario",
    Link: "Link",
}

export const TipoContattoOptions =
    Object.keys(TipoContatto).map(e => {
        return {
            label: e,
            tipo: TipoContatto[e],
        }
    })

export const ValoreRuoli = {
    SystemReserved: 0,
    Amministratore: 10,
    Gestore: 20,
    Redattore: 30,
}